import React from 'react';

import { colors } from '@/theme/colors';

export type CarImagePlaceholderProps = {
  size?: { width: number; height: number };
  color?: string;
  style?: React.CSSProperties;
};

export default function CarImagePlaceholder({
  size = { width: 25, height: 25 },
  color = colors.neutral10,
  style,
}: CarImagePlaceholderProps) {
  return (
    <svg
      width={`${size.width}px`}
      height={`${size.height}px`}
      viewBox={`0 0 ${size.width} ${size.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0_225_1946)">
        <path
          d="M22.25 0.75H2.75C1.92157 0.75 1.25 1.42157 1.25 2.25V21.75C1.25 22.5784 1.92157 23.25 2.75 23.25H22.25C23.0784 23.25 23.75 22.5784 23.75 21.75V2.25C23.75 1.42157 23.0784 0.75 22.25 0.75Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.25 18.25H23.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 8V6.5C17 6.10218 16.842 5.72064 16.5607 5.43934C16.2794 5.15804 15.8978 5 15.5 5H9.5C9.10218 5 8.72064 5.15804 8.43934 5.43934C8.15804 5.72064 8 6.10218 8 6.5V8L5.75 11.007V14H19.25V11.007L17 8Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.75 11H8.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.25 11H19.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.25 14V15.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.75 14V15.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M25.8815 7L30.8592 8.63744C30.976 8.67591 31.084 8.73672 31.177 8.8164C31.27 8.89607 31.3462 8.99305 31.4012 9.10179C31.4562 9.21053 31.489 9.32891 31.4977 9.45016C31.5063 9.57141 31.4907 9.69316 31.4517 9.80845L25.5228 27.3675C25.4838 27.4828 25.4222 27.5894 25.3415 27.6812C25.2608 27.773 25.1625 27.8482 25.0524 27.9025C24.9422 27.9568 24.8223 27.9891 24.6995 27.9977C24.5766 28.0063 24.4533 27.9909 24.3365 27.9523L16.5 25.3746"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0_225_1946">
          <rect
            width="24"
            height="24"
            fill={colors.neutral100}
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
